'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVisibilityChangeNamespace = getVisibilityChangeNamespace;
function getVisibilityChangeNamespace(prefix) {
  return prefix + 'visibilitychange';
}